export function formatAddressWithLine1(address: {
  formatted: string;
  line1?: string;
}): string | undefined {
  if (!address?.formatted) {
    return undefined;
  }
  if (!address.line1) {
    return address.formatted;
  }

  const { line1, formatted } = address;
  if (formatted.indexOf(",") === -1) {
    return `${line1}, ${formatted}`;
  }

  const elements = formatted.split(",");
  if (elements.length < 4) {
    return `${line1}, ${formatted}`;
  }

  elements[0] = `${elements[0]} ${line1}`;
  return elements.join(",");
}
